import Layout from '@/AppMain.vue';

const discounts= {
    path: '/coupons',
    name: 'Coupons',
    component: Layout,
    children:[
        {
            path: '/coupons',
            name: 'Coupons',
            component: () => import('@/views/discounts/browse'),
            meta: {title: 'Coupons', name:'Coupons', user_permission:'browse_discounts', auth: true, back:'/', middlewares:['activeWebsite'], breadcrumbs: [{title: 'Dashboard', to: '/'}]}
        },
        {
            path: '/coupons/create/:type',
            name: 'Coupons',
            component: () => import('@/views/discounts/edit-add'),
            meta: {title: 'Coupons', name:'Coupons', auth: true, back:'/', middlewares:['activeWebsite'], breadcrumbs: [{title: 'Dashboard', to: '/'}, {title:"Discounts", to:'/discounts'}]}
        },
        {
            path: '/coupons/:id',
            name: 'Coupons',
            component: () => import('@/views/discounts/edit-add'),
            meta: {title: 'Coupons', name:'Coupons', auth: true, back:'/', middlewares:['activeWebsite'], breadcrumbs: [{title: 'Dashboard', to: '/'}, {title:"Discounts", to:'/discounts'}]}
        },
    ]
};
export default discounts;
